import request from '@/utils/request'

export const mektupGetir = (id) =>  {
    id = id || 0;
    return request({
        url: 'Mektup/belge?id=' + id,
    })
};

export const mektupIade = (id, aciklama) => {
    return request({
        url: 'Mektup/Iade',
        method: 'post',
        params: {
            id,
            aciklama
        }
    })
}


export const mektupKaydet = (data, tamamlandi) => {
    const params = {};
    
    if (tamamlandi)
        params["tamamlandi"] = tamamlandi;
    
    return request({
        url: 'Mektup/MektupPost',
        method: 'post',
        data,
        params
    })
};


export const mektupResmiGetir = (imageId) => {
    return process.env.VUE_APP_BASE_API_URL+'mektup/ResmiGetir?imageId='+imageId;
};

